import React, {Component} from "react";
import "../Tigerboxes.scss";
import "./TigerboxDetails.scss";
import {withToast} from "../../../util/ToastService";
import ErrorCodes from "../../../config/ErrorCodes";
import {ReleaseFromDevice, UpdateDeviceName, GetDeviceIcon, UpdateDeviceCurrentProfile} from "../TigerboxSevice";
import {TigerSpinner} from "../../../global/tiger-spinner/TigerSpinner";
import {Button, Form, FormControl, InputGroup, Modal} from "react-bootstrap";
import {
    BiPencil,
    } from "react-icons/bi";
import {
    FaCheck,
} from "react-icons/fa";
import {
    FiBox,
    FiCalendar,
    FiGlobe, FiHash,
    FiMusic,
    FiUser,
} from "react-icons/fi";
import {
    ImCross,
} from "react-icons/im";
import {
    IoIosArrowDropleft ,
} from "react-icons/io";
import Strings from "../../../config/Strings";
import {TigerButton} from "../../../global/tiger-button/TigerButton";
import GlobalConstants from "../../../config/GlobalConstants";
import {ConfirmationModal} from "../../../global/ConfirmationModal";
import {ConvertDateToReadableString} from "../../../util/ConverterUtil";
import {GetProfilesOfAccount} from "../../profiles/ProfileService";

class TigerboxDetails extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            device: null,
            isEditingName: false,
            isUpdating: false,
            showRemovingModal: false,
            showProfileModal: false,
            loadingAccountProfiles: false,
            accountProfiles: [],
            switchingProfile: false,
        };

        //Window title
        document.title = "Meine tigerbox :: tiger.media";
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        if (this.props.location.state?.device?.id) {
            this.setState({
                device: this.props.location.state.device
            });
            //Window title
            document.title = "tigerbox " + this.props.location.state.device.displayName + " :: tiger.media";
        } else {
            this.props.history.push("/" + GlobalConstants.APP_PATH + "tigerboxes");
        }
    }

    updateDeviceName() {
        if (this.state.newName) {
            UpdateDeviceName(this.state.device, this.state.newName).then(res => {
                if (!res.error) {
                    this.setState(prevState => ({
                        ...prevState,
                        device: {
                            ...prevState.device,
                            displayName: this.state.newName || prevState.displayName
                        },
                        isEditingName: false
                    }));
                }
            });
        }
    }

    async removeDeviceFromAccount() {
        if (this.state.device && this.state.device.id) {
            let res = await ReleaseFromDevice(this.state.device.id);
            if (!res.error) {
                window.location.href = GlobalConstants.UI_HOST + "tigerboxes";
            }
        }
    }

    openProfile = () => {
        const profile = this.state.device?._embedded?.profiles;
        if (profile?._links?.self?.href) {
            this.props.history.push({
                pathname: "/" + GlobalConstants.APP_PATH + "profile-details",
                state: profile._links.self.href.replace("{?projection}", "")
            });
        }
    }

    openChangeProfileModal = async () => {
        this.setState({showProfileModal: true, loadingAccountProfiles: true});
        const response = await GetProfilesOfAccount(this.props.accountId);
        if (!response.error) {
            this.setState({
                accountProfiles: response.result._embedded?.profiles || [],
                loadingAccountProfiles: false,
            });
        } else {
            this.props.addToast(Strings.TOAST_ERROR_FETCHING_DATA + ErrorCodes.CODE_PROFILES + " - " + response.message, {
                autoDismiss: true,
                appearance: 'error',
                placement: 'bottom-center'
            });
            this.setState({loadingAccountProfiles: false});
        }
    }

    selectProfile = async (profile) => {
        this.setState({switchingProfile: true});
        const response = await UpdateDeviceCurrentProfile(this.state.device.id, profile.id);
        if (!response.error) {
            this.setState(prevState => ({
                ...prevState,
                device: response.result,
                switchingProfile: false,
                showProfileModal: false,
            }));
            this.props.addToast(Strings.DEVICES_DETAILS_CHANGE_PROFILE_SUCCESS, {
                autoDismiss: true,
                appearance: 'success',
                placement: 'bottom-center'
            });
        } else {
            this.props.addToast(Strings.DEVICES_DETAILS_CHANGE_PROFILE_ERROR + response.message, {
                autoDismiss: true,
                appearance: 'error',
                placement: 'bottom-center'
            });
            this.setState({switchingProfile: false});
        }
    }

    getDeviceTypeName = () => {
        if (this.state.device?._embedded?.versions?.display) {
            return this.state.device._embedded?.versions?.display;
        } else {
            return Strings.DEVICES_DETAILS_TYPE_NAME_TIGERBOX_TOUCH;
        }
    }

    render() {
        let softwareVersion = "";
        if (this.state.device) {
            softwareVersion = this.state.device.currentVersion;
            if (softwareVersion && softwareVersion.indexOf("R1.00") < 0) { //extract version only from version string of rewritten software, otherwise it's everytime 1.00, which not helps
                softwareVersion = softwareVersion.slice(1, -22);
            }
        }
        return (
            <div className="content-box">
                <div className="content-details-header" style={{backgroundColor: "#838383"}} id="#title">
                    <a href={"/" + GlobalConstants.APP_PATH + "tigerboxes"}>
                        <IoIosArrowDropleft />
                    </a>&#xA0;&#xA0;{Strings.DEVICES_DETAILS_LABEL.replace("{0}", this.getDeviceTypeName())}
                </div>
                <div className="mb-4">
                    {!this.state.loading && this.state.device && (
                        <>
                            <div className="device-details-wrap">
                                <div className="cover-container">
                                    <div className="cover">
                                        <img src={GetDeviceIcon(this.state.device)} alt="cover" className="cover-img"/>
                                    </div>
                                </div>
                                <div className="py-4 px-2 w-100">
                                    <div>
                                        {this.state.isEditingName ? (
                                            <InputGroup className="w-100 mb-2">
                                                <FormControl
                                                    size="lg"
                                                    defaultValue={this.state.device.displayName}
                                                    isInvalid={this.state.newName == null || this.state.newName === ""}
                                                    onChange={e => this.setState({ newName: e.target.value })}
                                                />

                                                <Button
                                                    variant="danger"
                                                    onClick={() =>
                                                        this.setState({
                                                            isEditingName: false,
                                                            newName: this.state.device.displayName
                                                        })
                                                    }
                                                >
                                                    <ImCross />
                                                </Button>
                                                <Button
                                                    disabled={this.state.newName == null || this.state.newName === ""}
                                                    variant={(this.state.newName == null || this.state.newName === "") ? "secondary" : "success"}
                                                    onClick={() => this.updateDeviceName()}
                                                >
                                                    <FaCheck />
                                                </Button>
                                                <Form.Control.Feedback type="invalid">
                                                    {Strings.DEVICES_DETAILS_NAME_ERROR}
                                                </Form.Control.Feedback>
                                            </InputGroup>
                                        ) : (
                                            <h2>
                                                {this.state.device.displayName}
                                                {"  "}
                                                <Button
                                                    variant="outline-secondary"
                                                    className="mb-3 px-1 py-0 ml-2"
                                                    onClick={() => this.setState({isEditingName: true, newName: this.state.device.displayName})}
                                                >
                                                    <BiPencil />
                                                </Button>
                                            </h2>
                                        )}
                                    </div>
                                    <hr />
                                    <div className="device-infos-wrap mb-3">
                                        <div className="px-1 w-100">
                                            <FiUser class={"mb-2"}/> {Strings.DEVICES_DETAILS_DEVICE_PROFILE_LABEL}
                                        </div>
                                        <div className="px-1 w-100">
                                            <div className="device-infos-wrap">
                                                <div className="device-info">
                                                    {this.state.device._embedded?.profiles &&
                                                        <span className="tigerbox-active-profile" role="button" onClick={this.openProfile}>
                                                            <img className="profile-info-avatar" src={this.state.device._embedded.profiles._links?.avatar?.href} alt="" />
                                                            {this.state.device._embedded.profiles.name}
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <TigerButton
                                        type="button"
                                        variant="purple"
                                        className="btn-ci-sm info-column-button mb-3 small-height"
                                        onClick={this.openChangeProfileModal}
                                    >
                                        {Strings.DEVICES_DETAILS_CHANGE_PROFILE_BUTTON}
                                    </TigerButton>
                                    <hr />
                                    <div className="device-infos-wrap mb-4">
                                        <div className="px-1 w-100 device-general-details">
                                            {this.getDeviceTypeName()}
                                        </div>
                                    </div>
                                    <div className="device-infos-wrap">
                                        <div className="px-1 w-100" >
                                            <FiHash class={"mb-2"}/> {Strings.DEVICES_DETAILS_DEVICE_IDENTIFIER_LABEL}
                                        </div>
                                        <div className="px-1 w-100">
                                            <div className="device-infos-wrap">
                                                <div className="device-info">
                                                    {this.state.device.deviceIdentifier}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="device-infos-wrap">
                                        <div className="px-1 w-100">
                                            <FiBox class={"mb-2"}/> {Strings.DEVICES_DETAILS_DEVICE_VERSION_LABEL}
                                        </div>
                                        <div className="px-1 w-100">
                                            <div className="device-infos-wrap">
                                                <div className="device-info">
                                                    {softwareVersion}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="device-infos-wrap">
                                        <div className="px-1 w-100">
                                            <FiGlobe class={"mb-2"}/> {Strings.DEVICES_DETAILS_DEVICE_LOCAL_IP_ADDRESS_LABEL}
                                        </div>
                                        <div className="px-1 w-100">
                                            <div className="device-infos-wrap">
                                                <div className="device-info">
                                                    {this.state.device.localIpAddress}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {this.state.device.firstOnboardedDateCurrentAccount != null &&
                                        <div className="device-infos-wrap">
                                            <div className="px-1 w-100">
                                                <FiCalendar class={"mb-2"}/> {Strings.DEVICES_DETAILS_DEVICE_FIRST_ONBOARDED_AT_LABEL}
                                            </div>
                                            <div className="px-1 w-100">
                                                <div className="device-infos-wrap">
                                                    <div className="device-info">
                                                        {ConvertDateToReadableString(this.state.device.firstOnboardedDateCurrentAccount)}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    <div className="device-infos-wrap">
                                        <div className="px-1 w-100">
                                            <FiMusic class={"mb-2"}/> {Strings.DEVICES_DETAILS_DEVICE_PREMIUM_ACCESS_LABEL}
                                        </div>
                                        <div className="px-1 w-100">
                                            <div className="device-infos-wrap">
                                                <div className="device-info">
                                                    {this.state.device.premiumAccessAvailable
                                                        ? Strings.DEVICES_DETAILS_DEVICE_PREMIUM_ACCESS_YES
                                                        : Strings.DEVICES_DETAILS_DEVICE_PREMIUM_ACCESS_NO}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <hr />
                                    {this.state.device &&
                                        <TigerButton
                                            className="btn-ci-sm btn-ci-hover info-column-button small-height"
                                            variant="red"
                                            onClick={() => this.setState({showRemovingModal: true})}
                                        >
                                            {Strings.DEVICES_REMOVE_FROM_ACCOUNT_BUTTON}
                                        </TigerButton>
                                    }
                                </div>
                            </div>
                        </>
                    )}

                    {this.state.loading && <TigerSpinner/>}
                </div>

                <ConfirmationModal
                    title={Strings.DEVICES_REMOVE_WARNING_TITLE}
                    text={Strings.DEVICES_REMOVE_WARNING_BODY.replace("{0}", this.state.device && this.state.device.displayName)}
                    actionButtonLabel={Strings.DEVICES_REMOVE_WARNING_BUTTON}
                    actionButtonVariant="danger"
                    onActionPress={() => this.removeDeviceFromAccount()}
                    show={this.state.showRemovingModal}
                    onHide={() => this.setState({showRemovingModal: false})}
                />

                <Modal show={this.state.showProfileModal} onHide={() => this.setState({showProfileModal: false})} centered>
                    <Modal.Header>
                        <Modal.Title>{Strings.DEVICES_DETAILS_CHANGE_PROFILE_DIALOG_TITLE}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {this.state.loadingAccountProfiles || this.state.switchingProfile ? (
                            <TigerSpinner/>
                        ) : (
                            <div className="change-profile-list">
                                {this.state.accountProfiles.map(profile => (
                                    <div
                                        key={profile.id}
                                        role="button"
                                        className={"change-profile-item" + (profile.id === this.state.device?.currentProfileId ? " active" : "")}
                                        onClick={() => this.selectProfile(profile)}
                                    >
                                        <img className="profile-info-avatar" src={profile._links?.avatar?.href} alt="" />
                                        {profile.name}
                                    </div>
                                ))}
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer className="h-100 d-flex justify-content-center">
                        <TigerButton
                            type="button"
                            className="btn-ci-sm btn-ci-hover"
                            variant="gray"
                            onClick={() => this.setState({showProfileModal: false})}
                        >
                            {Strings.MODAL_CLOSE_BUTTON}
                        </TigerButton>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default withToast(TigerboxDetails);